import { defineSmartFeedPiniaStore } from "@bloglovin/vue-framework";
import SmartFeedEngine from "SmartFeed/smart-feed-engine";
import { useGeneralStore } from "%/stores/general-store";


export const useCollectionFeedStore = defineSmartFeedPiniaStore("collection-feed-store", {
  state: () => ({
    visibility: "",
    orgId: null, // injected org id override, e.g. from UserProfile pages viewing another org
    metadata: {
      lastId: 0,
      hasMore: true,
      itemId: 0,
      itemContext: "",
    },
    smartFeedEngine: new SmartFeedEngine(),
  }),
  getters: {
    smartFeedRequestGetParams() {
      return {
        last_id: this.metadata.lastId,
        visibility: this.visibility,
        item_id: this.metadata.itemId,
        item_context: this.metadata.itemContext,
      };
    },
    feedUrl() {
      // Prefer the destination's own org; fall back to the viewer's.
      const store = useGeneralStore();
      const orgId = this.orgId || store.orgId || store.inspirationOrgId;
      return `/collections/${orgId}`;
    },
  },
});
